import { FC, ReactElement } from "react";

const Play:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path d="M23.537 9.796c2.083 2.084 3.124 4.811 3.123 7.543s-1.043 5.459-3.125 7.541c-2.083 2.081-4.808 3.123-7.539 3.123-2.736 0-5.464-1.043-7.545-3.125-2.083-2.083-3.123-4.811-3.123-7.541s1.041-5.459 3.123-7.541c0.52-0.521 0.52-1.365 0-1.885s-1.365-0.52-1.885 0c-2.603 2.603-3.904 6.017-3.904 9.427s1.301 6.824 3.904 9.427c2.603 2.604 6.017 3.907 9.428 3.907s6.825-1.301 9.429-3.904c2.604-2.603 3.907-6.017 3.907-9.427-0.001-3.415-1.303-6.827-3.904-9.429-0.52-0.521-1.365-0.521-1.885 0s-0.521 1.365 0 1.885zM14.667 2.667v13.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-13.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"></path>
        </svg>
    )
}

export default Play;